/* eslint-disable no-nested-ternary */
import { PropsWithChildren } from 'react';
import { Box, Stack } from '@mui/material';
import { modalModel } from 'entities/modal';
import { COLOR_BG, GRADIENT_ACCENT, useBreakpoints } from 'shared';
import { GRADIENT_ACCENT_2 } from 'shared/config';

import { calculateAngles } from './utils/calculateAngles';
import { innerCircleButtons, mainCircleButtons } from './constants';
import { CratCircleProps } from './crat-circle.types';
import { AbsoluteWrapper, CircleItem } from './item';
import { Logo } from './logo';

const CIRCLE_DIAMETER_LG = 783;
const CIRCLE_DIAMETER_MD = 470;

const INNER_CIRCLE_DIAMETER_LG = 483;
const INNER_CIRCLE_DIAMETER_MD = 300;

const mainAngles = calculateAngles(mainCircleButtons.length);
const innerAngles = calculateAngles(innerCircleButtons.length);

const OuterCircle = ({ diameter, children }: PropsWithChildren<{ diameter: number }>) => (
  <Box
    sx={{
      width: diameter,
      height: diameter,
      border: `1px dashed ${COLOR_BG}`,
      borderRadius: '50%',
      background: GRADIENT_ACCENT,
      position: 'relative',
    }}
  >
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        background: COLOR_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </Box>
  </Box>
);

const InnerCircle = ({ diameter, children }: PropsWithChildren<{ diameter: number }>) => (
  <Box
    sx={{
      position: 'relative',
      width: diameter,
      height: diameter,
      borderRadius: '50%',
      border: `2px dashed ${COLOR_BG}`,
      background: GRADIENT_ACCENT_2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        background: COLOR_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </Box>
  </Box>
);

export const CratCircleDesktop = ({ sx, onButtonClick }: CratCircleProps) => {
  const { isDownMdLayout } = useBreakpoints();

  const circleWidth = isDownMdLayout ? CIRCLE_DIAMETER_MD : CIRCLE_DIAMETER_LG;
  const innerCircleWidth = isDownMdLayout ? INNER_CIRCLE_DIAMETER_MD : INNER_CIRCLE_DIAMETER_LG;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" sx={{ ...sx }}>
      <OuterCircle diameter={circleWidth}>
        {mainCircleButtons.map((btn, index) => (
          <AbsoluteWrapper key={btn.modal} angle={mainAngles[index]} circleWidth={circleWidth} withLine>
            <CircleItem onClick={() => onButtonClick(btn.modal)} Icon={btn.Icon} title={btn.title} />
          </AbsoluteWrapper>
        ))}
        <InnerCircle diameter={innerCircleWidth}>
          <Logo onClick={() => onButtonClick(modalModel.ModalType.CratNew)} />
          {innerCircleButtons.map((btn, index) =>
            btn ? (
              <AbsoluteWrapper key={btn.modal} angle={innerAngles[index]} circleWidth={innerCircleWidth}>
                <CircleItem onClick={() => onButtonClick(btn.modal)} Icon={btn.Icon} title={btn.title} />
              </AbsoluteWrapper>
            ) : null,
          )}
        </InnerCircle>
      </OuterCircle>
    </Stack>
  );
};
